const tableRouter = {
  path: '/searchRankings',
  redirect: '/searchRankings/KeywordsRanking',
  name: 'searchRankings',
  component: () => import('@/views/layout/layout.vue'),
  meta: {
    title: '搜索排行',
  },
  children: [
    {
      path: 'KeywordsRanking',
      component: () => import('@/views/searchRankings/KeywordsRanking'),
      name: 'KeywordsRanking',
      meta: {
        title: '关键词排行',
      },
      props: true,
    },
  ],
};

export default tableRouter;
